<template>
  <div>
      <div dir="rtl" :key="key" v-for="(value, key) in payload.attribute.data">
        <p>
          <b>{{ key }}: </b>{{ value }}
        </p>
      </div>
  </div>
</template>
<script>
export default {
  name: 'extra-attributes-form',
  props: ['payload']
}
</script>
